export enum FormInputTypes {
  ADDRESS_AUTOCOMPLETE = 'addressautocomplete',
  LABEL = 'label',
  FIND_CAR = 'findcar',
  DATE_INPUT = 'dateinput',
  DOB = 'dob',
  TITLE_NAME = 'titlename',
  CUSTOM = 'custom',
  GENDER = 'gender',
  CALL_TO_ACTION_CARD = 'calltoactioncard',
  DISCLAIMER = 'disclaimer',
  SECTION_PANEL = 'sectionpanel',
  PAYMENT_SECTION = 'paymentsection',
  DATEPICKER = 'datepicker',
  TEXTAREA = 'textarea',
  LOGINBUTTON = 'loginButton',
  CTABANNER = 'ctabanner',
  RADIO_CARD_LIST = 'radioCardList',
  PROGRESS_TRACKER = 'progresstracker',
  PHONE_NUMBER = 'tel',
  PANEL_TITLE = 'paneltitle',
  CHECKBOX = 'checkbox',
  CUSTOM_EMAIL_CONFIRMATION = 'customemailconfirmation',
  PAYMENT_HEADER = 'paymentheader',
  SLIDER = 'slider',
  DIVIDER = 'divider',
  CURRENCY = 'currency',
  LINKPANEL = 'linkpanel',
  PROMO_CARD_MINI_LIST = 'promocardminilist',
  PROMO_CARD_BASIC_LIST = 'promocardbasiclist',
  DROPDOWN = 'dropdown',
}
